export default [
  {
    description: 'Tipo de Dado',
    path: '/ged/tipo-dado',
    name: 'ged-tipodado',
    component: () => import('@/views/ged/gedtipodado/Index.vue'),
    goesToMenu: true,
  },
];
